import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiTableCell: Components<Theme>['MuiTableCell'] = {
  styleOverrides: {
    root: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    head: ({ theme }) => ({
      color: colors.gray[500],
      backgroundColor: colors.gray[50],
      borderBottom: `1px solid ${theme.palette.divider}`,
      ...theme.applyStyles('dark', {
        backgroundColor: colors.black[850],
        color: colors.black[200],
      }),
    }),
    body: ({ theme }) => ({
      color: colors.black[950],
      backgroundColor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider}`,
      ...theme.applyStyles('dark', {
        color: colors.black[200],
      }),
    }),
  },
};
